<div *ngIf="apiKey">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>key</mat-icon> {{!apiKey.id ? 'Create new API Key' : ('API Key ' + apiKey.name)}}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid || !apiKey.services?.length">
        <mat-icon>{{!apiKey.id ? 'add' : 'save'}}</mat-icon>
        {{apiKey.id ? 'Update' : 'Add'}}
      </button>
      <micro-delete-confirm *ngIf="apiKey.id" (onConfirm)="delete()"></micro-delete-confirm>
    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="Details">
      <div class="padded vbox-space">
        <form #form="ngForm" role="form" class="vbox">
          <table class="basicTable vtable">
        <thead>
        <tr>
          <th colspan="100">API Key Configuration</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="authService.isSystemUser()">
          <th><micro-valid-label for="companyId" [model]="companyId" label="Company"></micro-valid-label></th>
          <td>
            <micro-company-select #companyId="ngModel"
                                  [(ngModel)]="apiKey.companyId"
                                  [required]="true"
                                  id="companyId"
                                  name="companyId">
            </micro-company-select>
          </td>
        </tr>
        <tr>
          <th><micro-valid-label for="name" [model]="name" label="Name"></micro-valid-label></th>
          <td>
            <input #name="ngModel" [(ngModel)]="apiKey.name" required placeholder="Name" id="name" name="name">
          </td>
        </tr>
        <tr>
          <th><micro-valid-label for="apiKey" [model]="apiKeyValue" label="API Key"></micro-valid-label></th>
          <td>
            <div class="hbox">
              <input #apiKeyValue="ngModel"  style="width: 50%" [(ngModel)]="apiKey.apiKey" required minlength="32" [disabled]="apiKey.id" placeholder="API key" id="apiKey" name="apiKey">
              <button *ngIf="apiKey.id"
                      mat-icon-button
                      type="button"
                      style="width: 24px; height: 24px; min-width: 24px; line-height: 24px; padding: 0;"
                      [matTooltip]="apiKey.apiKey?.length !== 32 ?'Enter 32 character key' : 'Copy API key'"
                      aria-label="Copy API key"
                      [disabled]="apiKey.apiKey?.length !== 32"
                      (click)="copyApiKey()">
                <mat-icon [style.color]="apiKey.apiKey?.length !== 32 ? 'red' : 'green'"
                          style="width: 16px; height: 16px; line-height: 16px; font-size: 16px;">content_copy</mat-icon>
              </button>
              <button *ngIf="!apiKey.id" mat-raised-button type="button" (click)="generateApiKey()">Generate Key</button>
            </div>
          </td>
        </tr>
        <tr>
          <th>Proxy User</th>
          <td>
            <micro-user-select [companyId]="apiKey.companyId" [(userId)]="apiKey.proxyUserId"></micro-user-select>
          </td>
        </tr>
        <tr>
          <th>Created By</th>
          <td>
            <micro-user-lookup [userId]="apiKey.createdBy"></micro-user-lookup>  on {{apiKey.createDate | dateTime}}
          </td>
        </tr>
        <tr>
          <th [ngClass]="apiKey.disabled ? 'CRITICAL' : ''">Disabled</th>
          <td>
            <input [(ngModel)]="apiKey.disabled" type="checkbox" id="disabled" name="disabled">
          </td>
        </tr>
        <tr>
          <th class="text-center" colspan="100" [ngClass]="{'text-error': !apiKey.services?.length}">
            Services (at least one required)
          </th>
        </tr>
        <tr>
          <td colspan="100">
            <micro-service-multiselect [companyId]="apiKey.companyId" [(selectedServices)]="apiKey.services"></micro-service-multiselect>
          </td>
        </tr>
        </tbody>
          </table>
        </form>
      </div>
    </mat-tab>
    <mat-tab *ngIf="apiKey.id" label="Audit History">
      <ng-template matTabContent>
        <micro-audits objectType="ApiKey" [objectId]="apiKey.id"></micro-audits>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
